import React from 'react';

import { COLORS } from '@constants/colors';

interface ToggleProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
}

const Toggle: React.FC<ToggleProps> = ({
  label,
  checked,
  onChange,
  className = '',
}) => {
  return (
    <div className={className || 'mb-8'}>
      <div className="flex items-center justify-between mb-4">
        <label
          htmlFor={`toggle-${label}`}
          className="text-sm font-semibold"
          style={{ color: COLORS.charcoal }}
        >
          {label}
        </label>
        <div className="relative">
          <input
            type="checkbox"
            id={`toggle-${label}`}
            checked={checked}
            onChange={e => onChange(e.target.checked)}
            className="sr-only"
          />
          <label
            htmlFor={`toggle-${label}`}
            className={`flex items-center cursor-pointer transition-all duration-300 ${
              checked ? 'text-blue-600' : 'text-gray-400'
            }`}
          >
            <div
              className={`relative w-12 h-6 rounded-full transition-all duration-300 ${
                checked ? 'bg-blue-500' : 'bg-gray-300'
              }`}
            >
              <div
                className={`absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full shadow-md transition-transform duration-300 ${
                  checked ? 'translate-x-6' : 'translate-x-0'
                }`}
              />
            </div>
          </label>
        </div>
      </div>
    </div>
  );
};

export default Toggle;
